__turbopack_context__.v({
  "dot": "dvFVda_dot",
  "dotActive": "dvFVda_dotActive",
  "dots": "dvFVda_dots",
  "root": "dvFVda_root",
  "slide": "dvFVda_slide",
  "track": "dvFVda_track",
  "viewport": "dvFVda_viewport",
});
